export default __webpack_public_path__ + "static/media/h1-2.84f30fa6.jpg";